/**
 * Gift card amount picker
 * ----------------------------------------------------------------------------
 * Cosmetic partner to snippets/gift-card-amount-picker.liquid.
 *
 * The picker offers the same option through two controls: a row of buttons for
 * the popular amounts, and a dropdown holding the rest. Both carry the class
 * and the data-option-position the theme's own variant code looks for, so
 * either already drives the price and the Add to cart state without any help
 * from this file. Selection is correct with scripting off.
 *
 * What this adds:
 *   - the "view more amounts" toggle, which reveals the dropdown. It is hidden
 *     in the markup and unhidden here, so a customer without scripting sees the
 *     dropdown open from the start rather than a button that does nothing.
 *   - keeping the two controls visually in step. The theme updates the price
 *     but leaves whichever control you did not touch showing its old value, so
 *     picking from the dropdown would leave a button still highlighted, and
 *     vice versa. Purely presentational.
 */
(function () {
  'use strict';

  function initPicker(root) {
    var toggle = root.querySelector('[data-gift-card-more-toggle]');
    var more = root.querySelector('[data-gift-card-more]');
    var select = root.querySelector('[data-gift-card-more-select]');
    var radios = root.querySelectorAll('[data-gift-card-amount]');

    // Only the buttons rendered, or the setting matched nothing: nothing to do.
    if (!toggle || !more || !select) {
      return;
    }

    // Scripting is available, so the toggle becomes real -- but only when
    // there is something for it to reveal. When the current amount is one of
    // the hidden ones, Liquid has already left the dropdown open, and offering
    // a "view more" button above an open dropdown reads as a bug.
    if (more.hidden) {
      toggle.hidden = false;
    }

    toggle.addEventListener('click', function () {
      more.hidden = false;
      toggle.hidden = true;
      select.focus();
    });

    // Choosing a listed amount clears the dropdown back to its placeholder, so
    // it does not sit there claiming a value that is no longer selected.
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () {
        select.value = '';
      });
    }

    // Choosing from the dropdown clears the buttons, for the same reason in
    // reverse. The theme has already updated the price by this point; this only
    // removes the stale highlight.
    select.addEventListener('change', function () {
      if (select.value === '') {
        return;
      }

      for (var j = 0; j < radios.length; j++) {
        radios[j].checked = false;
      }
    });
  }

  function init() {
    var pickers = document.querySelectorAll('[data-gift-card-more]');

    for (var i = 0; i < pickers.length; i++) {
      var root = pickers[i].closest('.product-form__option');

      if (root) {
        initPicker(root);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
